module.exports = __webpack_public_path__ + "img/欧莱雅.18fd96ee.png";